module.exports = __webpack_public_path__ + "img/reportes.be3dc96e.png";